import { render, staticRenderFns } from "./TheProfile.vue?vue&type=template&id=55405ddf"
import script from "./TheProfile.vue?vue&type=script&lang=js"
export * from "./TheProfile.vue?vue&type=script&lang=js"
import style0 from "./TheProfile.vue?vue&type=style&index=0&id=55405ddf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/salonhomepage/client/components/Breadcrumbs.vue').default})
